var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99998 1.19994C9.99407 1.19994 10.7999 2.00576 10.7999 2.99985C10.7999 3.99394 9.99407 4.79977 8.99998 4.79977H6.6001V5.99971H8.99998C10.6567 5.99971 11.9998 4.65661 11.9998 2.99985C11.9998 1.34308 10.6567 0 8.99998 0H6.6001V1.19994H8.99998Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99985 1.19994H5.39974V0H2.99985C1.34308 0 0 1.34308 0 2.99985C0 4.65661 1.34308 5.99971 2.99985 5.99971H5.39974V4.79977H2.99985C2.00579 4.79977 1.19994 3.99394 1.19994 2.99985C1.19994 2.00576 2.00579 1.19994 2.99985 1.19994Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.801 3.59997H4.20117V2.40002H7.801V3.59997Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskLink);
export default __webpack_public_path__ + "static/media/task-link.4ccfee81abf01127b371bc4deb36ed46.svg";
export { ForwardRef as ReactComponent };